import * as React from 'react';
import { Image, UIHeading4 } from '@cian/ui-kit';

import { BuilderStats } from './components/BuilderStats';
import { Tag } from './components/Tag';
import { Link } from '../Link';
import { IBuildingsStatusInfo } from '../../types/newbuilding';

import * as styles from './BuilderInfo.css';

export interface IBuilderInfoProps {
  logoUrl?: string;
  name: string;
  stats?: IBuildingsStatusInfo;
  url?: string;
}

export const BuilderInfo: React.FC<IBuilderInfoProps> = ({ logoUrl, name, stats, url }) => {
  return (
    <div className={styles['container']} data-testid="BuilderInfo">
      <div className={styles['header']}>
        <Tag text="Застройщик" />
      </div>
      <div className={styles['content']}>
        <div className={styles['information']}>
          <UIHeading4 as="h3">{name}</UIHeading4>
          {stats && (
            <div className={styles['stats']}>
              <BuilderStats stats={stats} />
            </div>
          )}
          <div className={styles['developer-link']}>
            <Link href={url} target="_blank">
              Подробнее о застройщике
            </Link>
          </div>
        </div>
        {logoUrl && (
          <div className={styles['image-wrapper']}>
            <a className={styles['image']} href={url} title={name} target="_blank" rel="noreferrer">
              <Image src={logoUrl} alt={name} borderRadius="0" objectFit="contain" />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
